import React from 'react';
import type { RegistrationStatus } from '../../types/event';
import {
  builderStatusLabel,
  normalizeRegistrationStatus,
  STATUS_BADGE_STYLES,
} from '../../utils/registrationStatus';

interface RegistrationStatusBadgeProps {
  status: RegistrationStatus;
  label?: string;
  compact?: boolean;
  audience?: 'builder' | 'organizer';
  className?: string;
}

const RegistrationStatusBadge: React.FC<RegistrationStatusBadgeProps> = ({
  status,
  label,
  compact = false,
  className = '',
}) => {
  const normalized = normalizeRegistrationStatus(status);
  const displayLabel = label || builderStatusLabel(status);
  const style = STATUS_BADGE_STYLES[normalized] || STATUS_BADGE_STYLES[status] || STATUS_BADGE_STYLES.pending_approval;

  return (
    <span
      className={`inline-flex items-center shrink-0 font-medium rounded-full ${compact ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1'} ${style} ${className}`}
    >
      {displayLabel}
    </span>
  );
};

export default RegistrationStatusBadge;
